import styled from "styled-components"
import { colors, rotate, appearing } from "../styles/design.config"
import ChaintrustLogo from "../assets/chaintrust-logo.webp"

export type PageLoadingVariant = "fullPage" | "inline"

interface PageLoadingProps {
  /** "fullPage" covers the viewport (e.g. root Suspense). "inline" fills its container (e.g. Office content). */
  variant?: PageLoadingVariant
}

const Wrapper = styled.div<{ $variant: PageLoadingVariant }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ $variant }) => ($variant === "inline" ? "2rem" : "3rem")};
  background: ${colors.clearBlue};
  animation: ${appearing} 0.2s ease-out forwards;
  ${({ $variant }) =>
    $variant === "fullPage"
      ? `
    position: fixed;
    inset: 0;
    z-index: 9999;
  `
      : `
    flex: 1;
    min-height: 20rem;
  `}
`

const Logo = styled.img`
  object-fit: contain;
  display: block;
`

const Spinner = styled.div`
  width: 4rem;
  height: 4rem;
  border: 3px solid ${colors.lavender};
  border-top-color: ${colors.shamrock};
  border-radius: 50%;
  animation: ${rotate} 0.8s linear infinite;
`

export const PageLoading = ({ variant = "fullPage" }: PageLoadingProps) => (
  <Wrapper $variant={variant} data-cy="page-loading" data-variant={variant}>
    <Logo src={ChaintrustLogo} alt="Chaintrust" width={360} height={72} />
    <Spinner aria-label="Loading..." />
  </Wrapper>
)
